import { render, staticRenderFns } from "./AssistenteProcesso.vue?vue&type=template&id=36132995&scoped=true"
import script from "./AssistenteProcesso.vue?vue&type=script&lang=js"
export * from "./AssistenteProcesso.vue?vue&type=script&lang=js"
import style0 from "./AssistenteProcesso.vue?vue&type=style&index=0&id=36132995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36132995",
  null
  
)

export default component.exports